// src/components/ui/Button.js
import React from 'react';
import './ui.css';

const Button = ({ 
  children, 
  onClick, 
  disabled = false, 
  loading = false, 
  icon: Icon, 
  className = '', 
  style = {},
  fullWidth = true // 🌟 NAYA: डिफॉल्ट रूप से बटन को फुल विड्थ और सेंटर्ड रखेगा
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled || loading}
      className={`micro-click-pill ${className}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        background: 'linear-gradient(135deg, #0F172A, #1E293B)',
        color: '#FFFFFF',
        border: 'none',
        borderRadius: '16px',
        padding: '14px 20px',
        fontSize: '13.5px',
        fontWeight: '900',
        letterSpacing: '0.3px',
        textTransform: 'uppercase',
        cursor: disabled || loading ? 'not-allowed' : 'pointer',
        boxShadow: '0 8px 24px rgba(15, 23, 42, 0.16)',
        transition: 'all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)',
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        outline: 'none',
        width: fullWidth ? '100%' : 'auto', // 🌟 FIX: लेफ्ट साइड सुकड़ना बंद
        margin: '0 auto', // 🌟 FIX: हमेशा सेंटर अलाइन रखेगा
        ...style
      }}
    >
      {loading ? (
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ 
            width: '14px', 
            height: '14px', 
            border: '2px solid rgba(255,255,255,0.3)', 
            borderTop: '2px solid #ffffff', 
            borderRadius: '50%', 
            animation: 'spin 1s linear infinite' 
          }}></span>
          Loading...
        </span>
      ) : (
        <>
          {Icon && <Icon size={16} strokeWidth={3} style={{ flexShrink: 0 }} />}
          {children}
        </>
      )}
    </button>
  );
};

export default Button;